function install(vue) {

    const requireComponent = require.context("./", true, /\.vue$/)
    const arr = requireComponent.keys()
    console.log("组件路径：",arr)

    arr.forEach((fileSrc) => {

        const fileConfig = requireComponent(fileSrc)
        // console.log("fileConfig：",fileConfig)

        const name = fileConfig.default.name
        vue.component(name, fileConfig.default || fileConfig)
    })

    // console.log("组件注册成功")

}

export default install
